import { createUseStyles } from '@glu/theming';

const styles = {
  labelContainer: {
    display: 'flex'
  },
  balance: {
    marginLeft: 15
  }
};

export default createUseStyles(styles);
